// Centralized data-testid constants for Tecnografic site.
// Keep names kebab-case and describe function, not styling.

export const NAV = {
  root: "main-navigation",
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkPortfolio: "nav-link-portfolio",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaQuote: "nav-cta-quote",
  mobileToggle: "nav-mobile-toggle",
  mobileSheet: "nav-mobile-sheet",
};

export const HOME = {
  hero: "home-hero",
  heroCta: "home-hero-cta",
  heroCtaSecondary: "home-hero-cta-secondary",
  trustBar: "home-trust-bar",
  servicesGrid: "home-services-grid",
  capabilities: "home-capabilities",
  processSteps: "home-process-steps",
  ctaSection: "home-cta-section",
};

export const SERVICES = {
  root: "services-page",
  card: (slug) => `service-card-${slug}`,
};

export const PORTFOLIO = {
  root: "portfolio-page",
  filterAll: "portfolio-filter-all",
  filterHydro: "portfolio-filter-hydro",
  filterDash: "portfolio-filter-dash",
  filterCustom: "portfolio-filter-custom",
  grid: "portfolio-grid",
};

export const ABOUT = {
  root: "about-page",
  stats: "about-stats",
  timeline: "about-timeline",
};

export const CONTACT = {
  root: "contact-page",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  phone: "contact-input-phone",
  company: "contact-input-company",
  projectType: "contact-select-project-type",
  message: "contact-textarea-message",
  submit: "contact-submit-button",
  success: "contact-success-banner",
  error: "contact-error-banner",
};

export const FOOTER = {
  root: "site-footer",
  contactBlock: "footer-contact-block",
};
